module.exports = __webpack_public_path__ + "img/t-logo.13f563ee.svg";